import { combineReducers } from "redux";
import signalR from "./signalR";
import api from "./api";
import customers from "./customers";
import sites from "./sites";
import gateways from "./gateways";
import controllers from "./controllers";
import alerts from "./alerts";
import wna from "./website";
import user from "./user";
import parametersInfo from "./parametersInfo";
import translations from "./translations";
import generalSettings from "./generalSettings";
import appConfigurations from "./appConfigurations";
import organizationAppConfigurations from "./organizationAppConfigurations";
import configuration from "./configuration";

export default combineReducers({
  signalR,
  api,
  appConfigurations,
  organizationAppConfigurations,
  configuration,
  customers,
  sites,
  gateways,
  controllers,
  alerts,
  wna,
  user,
  parametersInfo,
  translations,
  generalSettings,
});
